import React, { useState } from 'react';
import { miscForms } from '../../mock';
import { FileText, Printer, CheckSquare, Square } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '../../lib/utils';

export default function MiscForms() {
  const [selected, setSelected] = useState(new Set(['borrower_auth']));

  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id); else next.add(id);
    setSelected(next);
  };

  return (
    <div className="rounded-2xl border hairline bg-white p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-neutral-500 font-bold">Documents</div>
          <h3 className="display text-[18px] font-bold text-neutral-900 tracking-tight">Misc Forms</h3>
        </div>
        <div className="flex gap-2">
          <button onClick={() => toast('Preparing approval letter')} className="text-[11px] font-bold px-2.5 py-1.5 rounded-md bg-neutral-900 text-white hover:bg-neutral-800">Print Approval</button>
          <button onClick={() => toast('Preparing 1008 transmittal')} className="text-[11px] font-bold px-2.5 py-1.5 rounded-md border hairline text-neutral-700 hover:border-neutral-400">Print 1008</button>
        </div>
      </div>

      <div className="flex items-center justify-between text-[10.5px] text-neutral-500 mb-2">
        <button onClick={() => setSelected(new Set(miscForms.map((f) => f.id)))} className="hover:text-neutral-900 font-bold">Select all</button>
        <button onClick={() => setSelected(new Set())} className="hover:text-neutral-900 font-bold">Deselect all</button>
      </div>

      <div className="rounded-xl border hairline divide-y divide-neutral-100 overflow-hidden">
        {miscForms.map((f) => {
          const isChecked = selected.has(f.id);
          return (
            <button
              key={f.id}
              onClick={() => toggle(f.id)}
              className={cn(
                'w-full flex items-center gap-3 px-3.5 py-2.5 text-left transition',
                isChecked ? 'bg-[hsl(var(--kf-gold-soft))]/50' : 'bg-white hover:bg-neutral-50'
              )}
            >
              {isChecked ? (
                <CheckSquare className="h-4 w-4 text-[hsl(var(--kf-gold-deep))]" />
              ) : (
                <Square className="h-4 w-4 text-neutral-300" />
              )}
              <FileText className="h-4 w-4 text-neutral-400" />
              <span className="text-[12.5px] font-bold text-neutral-900 flex-1">{f.label}</span>
              <span className="mono text-[10.5px] text-neutral-400">{f.size}</span>
            </button>
          );
        })}
      </div>

      <button
        onClick={() => toast.success(`${selected.size} document(s) queued for print`)}
        className="mt-4 w-full h-10 rounded-xl btn-ink text-[12.5px] font-semibold flex items-center justify-center gap-2 transition"
      >
        <Printer className="h-4 w-4" /> Print Selected ({selected.size})
      </button>
    </div>
  );
}
